// Opens a file from S3 given a presigned GET url minted by a LIMS *-get-read-url endpoint
// (the read-side companion to utils/s3Upload.js). The url is opaque + short-lived (1h), so
// callers resolve it on demand (on click / on view-open) rather than holding it in the store.
//
// `openPresignedFile` opens the file in a new tab (view / inline PDF); a no-op on a falsy url
// so a caller that failed to resolve one degrades quietly instead of opening "about:blank".

export function openPresignedFile(presignedUrl) {
  if (presignedUrl) window.open(presignedUrl, "_blank", "noopener")
}
